import AllApis from "app/Apis/apis";
import {
  CLEAR_USER_ERROR,
  LOAD_USER_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
} from "app/utils/constants/Constant/usersConstant";

import { Axios } from "index";
import Cookies from "js-cookie";

export const getUserDetails = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_USER_REQUEST });
    const data = await Axios.get(`${AllApis.users.getUserDetails}`);
    dispatch({ type: LOAD_USER_SUCCESS, payload: data.data.data.user });
  } catch (error) {
    console.log(error);
    dispatch({
      type: LOAD_USER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const clearUserDetailsError = () => async (dispatch) => {
  try {
    console.log("clear error");
    dispatch({ type: CLEAR_USER_ERROR });
  } catch (error) {
    console.log(error);
  }
};
